import React from 'react';

import {
  ConversationalAnalyticsChartProps,
  VegaMark,
  VegaMarkType,
} from '@atom/types/conversationalAnalytics';

import ConversationalAnalyticsAreaChart from './ConversationalAnalyticsAreaChart';
import ConversationalAnalyticsBarChart from './ConversationalAnalyticsBarChart';
import ConversationalAnalyticsLineChart from './ConversationalAnalyticsLineChart';
import ConversationalAnalyticsNotImplemented from './ConversationalAnalyticsNotImplemented';
import ConversationalAnalyticsPieChart from './ConversationalAnalyticsPieChart';
import ConversationalAnalyticsRectChart from './ConversationalAnalyticsRectChart';
import ConversationalAnalyticsRuleChart from './ConversationalAnalyticsRuleChart';
import ConversationalAnalyticsScatterChart from './ConversationalAnalyticsScatterChart';
import ConversationalAnalyticsSquareChart from './ConversationalAnalyticsSquareChart';
import ConversationalAnalyticsTextChart from './ConversationalAnalyticsTextChart';
import ConversationalAnalyticsTickChart from './ConversationalAnalyticsTickChart';

const getMarkType = (mark: VegaMarkType | VegaMark) =>
  typeof mark === 'string' ? mark : mark.type;

const ConversationalAnalyticsChart: React.FC<
  ConversationalAnalyticsChartProps
> = props => {
  const markType = getMarkType(props.spec.mark);

  const renderChart = () => {
    const components: Record<VegaMarkType, React.ElementType> = {
      bar: () => <ConversationalAnalyticsBarChart {...props} />,
      line: () => <ConversationalAnalyticsLineChart {...props} />,
      area: () => <ConversationalAnalyticsAreaChart {...props} />,
      point: () => <ConversationalAnalyticsScatterChart {...props} />,
      circle: () => <ConversationalAnalyticsScatterChart {...props} />,
      arc: () => <ConversationalAnalyticsPieChart {...props} />,
      rect: () => <ConversationalAnalyticsRectChart {...props} />,
      rule: () => <ConversationalAnalyticsRuleChart {...props} />,
      square: () => <ConversationalAnalyticsSquareChart {...props} />,
      text: () => <ConversationalAnalyticsTextChart {...props} />,
      tick: () => <ConversationalAnalyticsTickChart {...props} />,
    };

    const Component = components[markType];

    return Component ? (
      <Component />
    ) : (
      <ConversationalAnalyticsNotImplemented markType={markType} />
    );
  };

  return <>{renderChart()}</>;
};

export default ConversationalAnalyticsChart;
